import React from "react"

export default function PublicLayout (props) {
    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    )
}